import { getTitleColor } from "@/lib/titleColors";

function Title({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  const fromColor = getTitleColor(title);
  return (
    <h1
      className={
        "text-main-title text-transparent bg-clip-text inline-block bg-gradient-to-r text-clip overflow-visible w-fit"
      }
      style={{
        backgroundImage: `linear-gradient(to right, ${fromColor}, hsl(var(--primary)), hsl(var(--primary)))`,
      }}
    >
      {children}
    </h1>
  );
}

export default Title;
